export enum CloudTypes {
    AWS = 'AWS',
    AZURE = 'AZURE',
    GCP = 'GCP',
}
